import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=7b9aba45&scoped=true&"
import script from "./ProductEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9aba45",
  null
  
)

export default component.exports